<template>
  <div class="deviceList">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">设备管理</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>类型：</span>
            <el-select v-model="deciceType" filterable placeholder="请选择" size="small" @change="changeType">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入设备编号" v-model="keyword" prefix-icon="el-icon-search" size="small" type="text" :maxlength="20"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" class="search-input" clearable>
            </el-input>
          </div>
          <div class="select-container-box">
            <el-button size="small" type="info" plain @click="search" class="query">查询</el-button>
            <el-button size="small" type="info" plain @click="add" class="add" v-if="edit">增加</el-button>
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table :data="equipmentList" style="width: 100%">
          <i slot="empty">
            <span>暂无数据</span>
          </i>
          <!-- <el-table-column
            prop="factory"
            label="设备品牌"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column prop="iotId" label="设备ID" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="customNumber" label="设备编号" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" show-overflow-tooltip align="center" label="设备名称">
          </el-table-column>
          <el-table-column prop="sensorTypeTitle" label="传感器类型" align="center" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.sensorTypeTitle }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="simCardSerialNumber" show-overflow-tooltip align="center" label="SIM卡">
          </el-table-column>
          <el-table-column prop="base" align="center" show-overflow-tooltip label="绑定基地">
          </el-table-column>
          <el-table-column prop="pond" align="center" show-overflow-tooltip label="绑定塘口">
          </el-table-column>
          <!-- <el-table-column
            prop="alarmPhoneList"
            align="center"
            show-overflow-tooltip
            label="警报电话"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.alarmPhoneList.length==2">{{scope.row.alarmPhoneList.length?scope.row.alarmPhoneList[0]+','+scope.row.alarmPhoneList[1]:''}}</span>
            <span v-else>{{scope.row.alarmPhoneList[0]}}</span>
          </template>
          </el-table-column> -->
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="edit" class="content-calibrate" :class="
                  judgecalibrate(scope.row.sensorTypes)
                    ? 'calibrate'
                    : 'calibrates'
                " @click="calibration(scope.$index, scope.row)">校正</span>
              <span class="content-edit" v-if="
                  $store.state.curCompany.id !== '636089367965017082' ||
                  (scope.row.iotId !== '862289057266377' &&
                    scope.row.iotId !== '862289057266484')
                " @click="handleEdit(scope.$index, scope.row)">{{ edit ? "编辑" : "查看" }}</span>
              <span v-if="edit" v-show="false" class="content-del" @click="handleDelete(scope.$index, scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <page-change :pageInfo="pageInfo"></page-change>  -->
      <!-- 弹窗 -->
      <div v-if="dialogFormVisible" class="addIot">
        <el-dialog :title="titleName" :before-close="handleClose" :visible.sync="dialogFormVisible" width="766px">
          <el-form :model="equipmentValue" :rules="rules" ref="ruleForms" class="ruleForms">
            <el-form-item label="设备类型" prop="type" :label-width="formLabelWidth" v-show="false" v-if="this.titleName != '编辑设备'">
              <el-radio-group v-model="types" @change="changeTypes">
                <el-radio :label="1">水质监测</el-radio>
                <el-radio :label="2">渔控仪</el-radio>
              </el-radio-group>
              <!-- <el-select
                v-model="types"
                placeholder="请选择设备类型"
                @change="changeTyp"
                :disabled="!edit"
              >
                <el-option
                  v-for="(item, index) in typeData"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select> -->
            </el-form-item>

            <el-form-item label="设备ID" prop="iotId" :label-width="formLabelWidth">
              <el-input v-model="equipmentValue.iotId" :maxlength="num30" placeholder="请输入设备ID" :disabled="!edit" @blur="showSensorType"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-if="titleName === '添加设备'"></el-input>
              <el-input v-else v-model="equipmentValue.iotId" :maxlength="num30" placeholder="请输入设备ID" :disabled="!edit || titleName == '编辑设备'"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
            </el-form-item>
            <el-form-item label="设备名称" prop="name" :label-width="formLabelWidth">
              <el-input :disabled="!edit" v-model="equipmentValue.name" :maxlength="num30" placeholder="请输入设备名称,不超过30个字符"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
            </el-form-item>

            <el-form-item label="绑定基地" prop="fishBaseId" :label-width="formLabelWidth">
              <el-select v-model="equipmentValue.fishBaseId" placeholder="请选择基地" @change="changeBase" :disabled="!edit">
                <el-option v-for="(item, index) in baseList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="绑定塘口" prop="fishPondId" :label-width="formLabelWidth">
              <el-select :disabled="!edit" v-model="equipmentValue.fishPondId" placeholder="请选择塘口" @change="changePond">
                <el-option v-for="(item, index) in fishPond" :key="index" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="传感器类型" v-if="showSensorTypeSelect" prop="sensorType" :label-width="formLabelWidth">
              <el-select v-model="sensorTypes" placeholder="请选择传感器类型" multiple @change="groupByChange" :disabled="!edit">
                <el-option v-for="item in sensorTypeOptions" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开关个数" v-if="showSwitchCountInput" prop="dtuSwitchCount" :label-width="formLabelWidth">
              <el-input :disabled="!edit" v-model="equipmentValue.dtuSwitchCount" :maxlength="num30" placeholder="请输入开关个数"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
            </el-form-item>
            <el-form-item label="SIM卡" prop="simCardSerialNumber" :label-width="formLabelWidth">
              <el-input :disabled="!edit" v-model="equipmentValue.simCardSerialNumber" :maxlength="num30" placeholder="请输入SIM卡"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="edit">
            <el-button @click="cancel('ruleForms')">取 消</el-button>
            <el-button type="primary" @click="save('ruleForms')">保 存</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 校准 -->
      <div v-if="correct" class="correct">
        <el-dialog :before-close="handleClose" :visible.sync="correct" width="680px">
          <div class="tip">
            <div>
              <img src="../../../assets/images/warning.png" alt="" />
            </div>
            <p>非专业人士请勿操作,有可能导致误差</p>
          </div>
          <div class="content">
            <div class="con">
              <div class="title">校正步骤：</div>
              <p class="p1">第一步：请使用标配的软毛刷将传感器底部刷洗;</p>
              <p>第二步：将传感器置于空气中，10-30分钟后方可进行校准;</p>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel0()" class="cancel">取 消</el-button>
            <el-button type="primary" @click="save0()" class="save">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- //弹窗 -->
      <div v-if="correct0" class="correct">
        <el-dialog :title="titleName" :before-close="handleClose" :visible.sync="correct0" width="680px">
          <div class="tip">
            <div>
              <img src="../../../assets/images/warning.png" alt="" />
            </div>
            <p>校正进行中</p>
          </div>
          <div class="content">
            <div class="con1">
              <p class="isClear">传感器是否清洗干净了吗？</p>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel0()" class="cancel">取 消</el-button>
            <el-button type="primary" @click="save1()" class="save0">是的，执行下一步</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- //弹窗 -->
      <div v-if="correct1" class="correct">
        <el-dialog :title="titleName" :before-close="handleClose" :visible.sync="correct1" width="680px">
          <div class="tip">
            <div>
              <img src="../../../assets/images/warning.png" alt="" />
            </div>
            <p>校正进行中</p>
          </div>
          <div class="content">
            <div class="con1">
              <p class="isClear">是否放置在空气中？</p>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel0()" class="cancel">取 消</el-button>
            <el-button type="primary" @click="save2()" class="save0">是的，执行下一步</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- //是否开始校准 -->
      <div v-if="correct2" class="correct">
        <el-dialog :title="titleName" :before-close="handleClose" :visible.sync="correct2" width="680px">
          <div class="tip">
            <div>
              <img src="../../../assets/images/warning.png" alt="" />
            </div>
            <p>校正进行中</p>
          </div>
          <div class="content">
            <div class="con1">
              <p class="isClear">是否开始校正？</p>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel0()" class="cancel">取 消</el-button>
            <el-button type="primary" @click="save3()" class="save">是的</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import PageChange from "../../common/PageChange";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import { Message } from "element-ui";
import deviceSettingsModule from "../../../store/modules/deviceSetting";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "deviceManage",
  mixins: [mixins],
  // components: {
  //   PageChange
  // },
  data () {
    return {
      typeList: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "水质监测",
        },
        {
          id: 2,
          name: "渔控仪",
        },
      ],
      deciceType: 0,
      curDeviceType: 0,
      keyword: "",
      rowIds: "",
      correct: false,
      correct0: false,
      correct1: false,
      correct2: false,
      disabled: true,
      equipmentList: [],
      showSensorTypeSelect: false,
      showSwitchCountInput: false,
      sensorTypeOptions: [],
      // factoryList: [
      //   {
      //     value: "信立XL-68",
      //     key: 1
      //   },
      //   {
      //     value: "信立XL-70",
      //     key: 2
      //   },
      //   {
      //     value: "信立XL-80",
      //     key: 3
      //   }
      // ],

      num30: 30,
      num20: 20,
      num11: 11,
      formLabelWidth: "98px",
      titleName: "",
      dialogFormVisible: false,
      baseList: [], // 基地列表
      fishPond: [], // 塘口列表
      equipmentValue: {
        iotId: "Ylw-s-",
        name: "",
        fishBaseId: "",
        fishPondId: "",
        simCardSerialNumber: "",
        alarmPhone: "",
        alarmPhone2: "",
        alarmPhoneList: [],
        dtuSwitchCount: 0,
        // sensorType: 5
      },
      sensorTypes: [], //汇总方式
      types: 1,
      // typeData: [
      //   {
      //     id: 1,
      //     name: "水质监测"
      //   },
      //   {
      //     id: 2,
      //     name: "渔控仪"
      //   }
      // ],
      rules: {
        iotId: [{ required: true, message: "请输入设备ID", trigger: "blur" }],
        fishBaseId: [
          { required: true, message: "请选择所在基地", trigger: "blur" },
        ],
        // fishPondId: [
        //   { required: true, message: "请选择塘口", trigger: "change" }
        // ],
        name: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
          {
            pattern: /^.{1,30}$/,
            message: "设备名称范围:1-30个字符",
          },
        ],
        alarmPhone: [
          { required: false, message: "请输入报警电话", trigger: "blur" },
          {
            pattern:
              /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\\d{8}$||''/,
            message: "请输入正确的手机号码",
          },
        ],
        alarmPhone2: [
          { required: false, message: "请输入报警电话", trigger: "blur" },
          {
            pattern:
              /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\\d{8}$||''/,
            message: "请输入正确的手机号码",
          },
        ],
      },
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.getPondData, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
      rowId: "",
    };
  },
  watch: {
    whetherQlw() {
      this.initPagePermission();
    },
    // types(e) {
    //   if (e == 1) {
    //     this.equipmentValue.iotId = "Ylw-s-";
    //   } else if (e == 2) {
    //     this.equipmentValue.iotId = "Ylw-k-";
    //     this.showSensorTypeSelect = false;
    //     this.sensorTypes = [];
    //   }
    // },
  },
  async mounted () {
    this.search();
  },
  methods: {
    ...mapActions(deviceSettingsModule, ["getBaseKeyValue", "getFishPond"]),
    ...mapActions(deviceSettingsModule, [
      "getEquipmentList",
      "addEquipment",
      "deleteEquipment",
      "getEditView",
      "editEquipment",
      "calibrationDissolvedOxygen",
      "getSensorType",
      "getSensorTypeList",
    ]),
    changeTypes (e) {
      console.log(333, e);

      if (e == 1) {
        this.equipmentValue.iotId = ""//"Ylw-s-";
      } else if (e == 2) {
        this.equipmentValue.iotId = ""//"Ylw-k-";
        this.showSensorTypeSelect = false;
        this.showSwitchCountInput = false;
        this.sensorTypes = [];
      }
    },
    // 切换类型
    changeType (e) {
      this.search();
    },

    search () {
      let obj = {
        deciceType: this.deciceType,
        keyword: this.keyword,
      };
      this.getEquipmentList(obj)
        .then((rsp) => {
          this.equipmentList = rsp;
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error",
          });
          console.dir(err);
        });
    },
    //  点击空白处不关闭弹窗
    handleClose (done) {
      console.log(window.event);
      if (window.event && window.event.target.tagName !== "I") {
        return;
      } else {
        done();
      }
    },
    judgecalibrate (arr = []) {
      if (arr == null) {
        return false;
      }
      if (arr.includes(1) || arr.includes(8)) {
        console.log(33333);

        return true;
      } else {
        return false;
      }
    },
    // judgecalibrates(arr = []) {
    //   if (arr == null) {
    //     return false;
    //   }
    //   if (!arr.includes(1)) {
    //     //   return true;
    //     // } else {
    //     console.log(22222222222);

    //     return false;
    //   }
    // },
    async changeBase (index) {
      // 基地=>塘口 联动
      this.equipmentValue.fishPondId = "";
      this.fishPond = await this.getFishPond(this.equipmentValue.fishBaseId);
      this.fishPond = [
        {
          key: "",
          value: "全部",
        },
      ].concat(this.fishPond);
      this.equipmentValue.fishPondId = this.fishPond[0].key;
    },
    changePond (e) {
      this.$set(this.equipmentValue, this.equipmentValue.fishPondId, e);
    },

    async add () {
      this.types = 1;
      this.dialogFormVisible = true;
      this.equipmentValue = {};
      this.titleName = "添加设备";
      this.sensorTypes = [];
      this.showSensorTypeSelect = false;
      this.showSwitchCountInput = false;
      if (this.types == 1) {
        //this.equipmentValue.iotId = "Ylw-s-";
      }
      this.baseList = await this.getBaseKeyValue();
      this.equipmentValue.fishBaseId = this.baseList[0].key;
      this.fishPond = await this.getFishPond(this.equipmentValue.fishBaseId);
      this.fishPond = [
        {
          key: "",
          value: "全部",
        },
      ].concat(this.fishPond);
      this.equipmentValue.fishPondId = this.fishPond[1].key;
    },
    // 校准溶解氧
    calibration (index, row) {
      this.correct = true;
      this.rowIds = row.id;
      // console.log("tag", row.sensorTypes.includes(1));
      // if (
      //   row.sensorTypes.includes(1) !== true ||
      //   row.sensorTypes.includes(8) !== true
      // ) {
      //   return;
      // }
      // console.log("tag", 111);
      // this.$confirm(
      //   "该校准操作，会根据传感器当前温度空气中溶解氧的标准值进行校准。传感器需放置在空气中，静置一会，方可进行校准。是否立即开始校准",
      //   "提示",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //     showClose: false
      //   }
      // )
      //   .then(async () => {
      //     await this.calibrationDissolvedOxygen(row.id);
      //     this.$message({
      //       type: "success",
      //       message: "校准完成!"
      //     });
      //     this.getEquipmentList(index);
      //   })
      //   .catch(err => {
      //     this.$message({
      //       type: "error",
      //       message: err.response.data
      //     });
      //   });
    },
    save0 () {
      this.correct = false;
      this.correct0 = true;
      // this.$confirm("传感器是否清洗干净了吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     this.$confirm("是否放置在空气中？", "提示", {
      //       confirmButtonText: "确定",
      //       cancelButtonText: "取消",
      //       type: "warning"
      //     })
      //       .then(async () => {
      //         await this.calibrationDissolvedOxygen(this.rowIds);
      //         this.$message({
      //           type: "success",
      //           message: "校准完成!"
      //         });
      //       })
      //       .catch(err => {
      //         this.$message({
      //           type: "error",
      //           message: err.response.data
      //         });
      //       });
      //   })
      //   .catch(() => {});
    },
    cancel0 () {
      this.correct = false;
      this.correct0 = false;
      this.correct1 = false;
      this.correct2 = false;
    },
    save1 () {
      this.correct0 = false;
      this.correct1 = true;
    },
    save2 () {
      this.correct1 = false;
      this.correct2 = true;
    },
    save3 () {
      this.correct2 = false;
      this.calibrationDissolvedOxygen(this.rowIds)
        .then(() => {
          this.$message({
            type: "success",
            message: "校正完成!",
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.response.data,
          });
        });
    },
    // 编辑获取单个设备数据
    async handleEdit (index, row) {
      this.baseList = await this.getBaseKeyValue();
      this.titleName = "编辑设备";
      // this.disabled = true;
      this.dialogFormVisible = true;
      this.equipmentValue = {};
      let result = await this.getEditView(row.id);
      this.fishPond = await this.getFishPond(result.fishBaseId);
      this.getSensorTypeOptionsList(result.deviceType, result.sensorTypes)
      if (result.deviceType == 2 || result.deviceType == 4) {
        this.showSensorTypeSelect = true;
        this.showSwitchCountInput = true;
      } else if(result.deviceType === 8){//智控仪
         this.showSensorTypeSelect = true;
         this.showSwitchCountInput = false;
      }else {
        this.showSensorTypeSelect = false;
        this.showSwitchCountInput = false;
      }

      this.rowId = result.id;
      this.equipmentValue = {
        iotId: result.iotId,
        name: result.name,
        simCardSerialNumber: result.simCardSerialNumber,
        fishBaseId: result.fishBaseId,
        fishPondId: result.fishPondId,
        dtuSwitchCount: result.dtuSwitchCount,
        // alarmPhoneList: [result.alarmPhoneList[0], result.alarmPhoneList[1]],
        // alarmPhone: result.alarmPhoneList[0],
        // alarmPhone2: result.alarmPhoneList[1]
      };
    },
    // 删除设备
    handleDelete (index, row) {
      this.$confirm("是否删除此记录", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deleteEquipment(row.id);
          this.search();
          this.equipmentList.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error",
          });
        });
    },
    // 失去焦点触发事件
    async showSensorType () {
      console.log(8111989, this.equipmentValue.iotId);
      await this.getSensorType(this.equipmentValue.iotId)
        .then((rsp) => {
          const sensorTypeList = (rsp.sensorTypeList && rsp.sensorTypeList.length) ?  rsp.sensorTypeList : (rsp.deciceType === 8 ? [524288] : [8, 16]);
          this.getSensorTypeOptionsList(rsp.deviceType, sensorTypeList)
          if (rsp.deviceType == 2 || rsp.deviceType == 4) {
            this.showSensorTypeSelect = true;
            this.showSwitchCountInput = true;
          } else if(rsp.deviceType === 8){//智控仪
            this.showSensorTypeSelect = true;
            this.showSwitchCountInput = false;
          } else {
            this.showSensorTypeSelect = false;
            this.showSwitchCountInput = false;
          }
        })
        .catch((err) => {
          this.showSensorTypeSelect = false;
          this.showSwitchCountInput = false;
        });
    },
    groupByChange () { },
    // 设备的更新与添加
    save (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.equipmentValue.alarmPhoneList = [
          //   this.equipmentValue.alarmPhone,
          //   this.equipmentValue.alarmPhone2
          // ];
          if(this.curDeviceType === 8 && (!this.sensorTypes || this.sensorTypes.length !== 1)){
                this.$message({
                  type: "error",
                  message: "智控仪传感器类型有且只能有一个",
                });
                return;
          }

          let equipmentValue = JSON.parse(JSON.stringify(this.equipmentValue));
          console.log(6767, this.sensorTypes);
          equipmentValue.sensorType = this.sensorTypes.length
            ? this.sensorTypes.reduce((now, next) => Number(now) + Number(next))
            : 0;
          // console.log(
          //   33333,
          //   this.sensorTypes.reduce((now, next) => Number(now) + Number(next))
          // );
          console.log(122222, equipmentValue);

          if (this.titleName === "编辑设备") {
            this.editEquipment({
              id: this.rowId,
              arr: equipmentValue,
            })
              .then(() => {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
                this.dialogFormVisible = false;
                this.equipmentValue = {};
                setTimeout(async () => {
                  this.search();
                }, 500);
              })
              .catch((err) => {
                Message.error(err.response.data);
              });
          } else if (this.titleName === "添加设备") {
            this.addEquipment(equipmentValue)
              .then(() => {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
                this.dialogFormVisible = false;
                this.equipmentValue = {};
                setTimeout(async () => {
                  this.search();
                }, 500);
              })
              .catch((err) => {
                Message.error(err.response.data);
              });
          }
        }
      });
    },
    cancel () {
      this.dialogFormVisible = false;
      this.equipmentValue = {};
      this.types = 1;
      this.equipmentValue.iotId = "";
      this.showSensorTypeSelect = false;
      this.showSwitchCountInput = false;
    },
    async getSensorTypeOptionsList (deviceType, sensorTypeList) {
      this.curDeviceType = deviceType;
      this.sensorTypeOptions = [];
      this.sensorTypeOptions = await this.getSensorTypeList(deviceType);
      if(sensorTypeList && sensorTypeList.length){
        this.sensorTypes = sensorTypeList;
      }else{
        this.sensorTypes = [];
      }
    },
  },
};
</script>
<style lang="stylus">
.deviceList {
  .el-message-box__title {
    /* padding-left: 165px; */
    margin-bottom: 0;
    font-size: 18px;
    line-height: 1;
    color: #333;
    text-align: center;
  }

  .el-select .el-tag {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-color: transparent;
    margin: 2px 0 2px 14px;
    background-color: #f0f2f5;
  }

  // .content-calibrate {
  // // opacity:0;
  // font-family: MicrosoftYaHei;
  // font-size: 14px;
  // // margin-right: -20px;
  // cursor: not-allowed;
  // color: gray;
  // }
  .calibrate {
    // opacity:0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    margin-right: 20px;
    cursor: pointer;
    color: #45B6F6;
  }

  .calibrates {
    opacity: 0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    margin-right: 20px;
    cursor: pointer;
    color: gray;
  }

  .correct {
    .el-dialog {
      height: 480px;
      position: absolute;
      left: 50%;
      top: 70px;
      border-radius: 6px;
      margin-left: -340px;
    }

    .tip {
      display: flex;
      margin-top: 18px;

      p {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        padding-left: 19px;
      }
    }

    img {
      width: 36px;
      height: 36px;
    }

    .el-dialog__body {
      padding: 10px 40px;
      color: #606266;
      font-size: 14px;
    }

    .content {
      margin-top: 42px;
      width: 600px;
      height: 210px;
      background: rgba(246, 247, 247, 1);
      border-radius: 6px;

      .title {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }

      p {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        padding-top: 18px;
      }

      .p1 {
        padding-top: 24px;
      }

      .isClear {
        padding-top: 44px;
        text-align: center;
        display: flex;
        justify-content: center;
      }

      .con1 {
        padding-top: 38px;
      }

      .con {
        padding-top: 38px;
        margin-left: 41px;
      }
    }

    .dialog-footer {
      display: flex;
      justify-content: center;

      .cancel, .save {
        width: 100px;
        height: 40px;
        margin-top: 20px;
      }

      .save0 {
        width: 160px;
        height: 40px;
        margin-top: 20px;
      }

      .cancel {
      }

      .save {
        margin-left: 22px;
      }
    }
  }

  .addIot {
    .el-dialog {
      min-height: 600px;
      position: absolute;
      left: 50%;
      top: -50px;
      border-radius: 6px;
      margin-left: -340px;

      .el-dialog__header {
        border-radius: 6px 6px 0px 0px;
        padding: 16px 20px 16px;
        background: linear-gradient(270deg, rgba(51, 137, 255, 1), rgba(31, 156, 244, 1), rgba(49, 170, 255, 1));

        .el-dialog__title {
          color: #fff;
        }
      }

      .el-input {
        width: 500px;
      }

      .el-input__inner {
        width: 500px;
        margin-left: 10px;
      }

      .el-select.fishType .el-input, .el-select.fishName .el-input {
        width: 245px !important;
      }

      .el-select.fishType .el-input__inner, .el-select.fishName .el-input__inner {
        width: 245px !important;
      }

      .el-select.fishName {
        margin-left: 13px;
      }

      .el-form-item__content {
        z-index: 999999;
        line-height: 40px;
        position: relative;
        font-size: 14px;
      }

      .el-form .el-form-item .el-form-item__label {
        margin-left: 65px;
        color: #333;
        font-size: 16px;
        text-align: right;
      }

      .ruleForm {
        margin-left: 0px;
      }

      .el-dialog__close {
        color: #fff;
      }

      .el-dialog__footer {
        position: relative;
        bottom: 12px;
        padding: 0px 0px 0px 0px;
        margin-right: 370px;
      }

      .el-button--primary {
        margin-left: 20px;
        background: #3389ff;
      }

      .el-button {
        width: 100px;
        height: 40px;
      }

      .el-button--default {
        margin-left: 117px;
      }

      .el-form-item .el-form-item__label:before {
        position: absolute;
        top: 2px;
        left: -12px;
        color: #fe3223;
      }

      .el-form-item__error {
        padding-top: 2px;
        position: absolute;
        top: 100%;
        left: 74px;
      }

      .el-icon-date {
        position: relative;
      }

      .el-icon-date:before {
        content: '\E608';
        position: absolute;
        left: 13px;
        top: 3px;
      }
    }
  }
}
</style>
